import React, { useEffect, useRef, useState } from 'react'
import axios from "axios";

import currencies from '../../utils/currency.json'
import close from '../../images/Settings/close.svg'

function DeleteSubscriberModel(props) {
    const { isOpen, onClose, subsciberIds, hasPaidSubscription, fetchData, setShowNotification, setShowMultiNotify, setSelectedSubscriberLength, setSelectedItems, subscibersData, currencyData, toggleSelect, setToggleSelect } = props;
    const modelRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMassage, setErrorMassage] = useState('');

    let currencySymbol = '$'
    let remainCredits = 0;

    if (hasPaidSubscription) {
        currencySymbol = currencies[currencyData?.currency?.toUpperCase()]?.symbol_native || '$';

        remainCredits = 0;
    
        for (const subscriberData of subscibersData) {
            remainCredits += subscriberData?.remainingCredits || 0;
        }
        
        // If necessary, you can scale the remaining credits by dividing by 100:
        remainCredits = parseFloat( (remainCredits / 100).toFixed(2));
    }

    const modelTitle = (subsciberIds.length > 1) ? 'Delete subscibers' : 'Delete subsciber';
    let modelDesc = '';

    if (hasPaidSubscription) {
        modelDesc = (subsciberIds.length > 1) 
            ? `Please note that this action cannot be undone. All selected subscribers will be removed, and a total refund of ${currencySymbol}${remainCredits} ${currencyData?.currency?.toUpperCase() || 'USD'} for the remaining subscription period will be sent from your Stripe account. Please ensure you have sufficient funds in your Stripe balance to process the refund before proceeding.`
            : `Please note that this action cannot be undone. The subscriber will be removed, and a refund of ${currencySymbol}${remainCredits} ${currencyData?.currency?.toUpperCase() || 'USD'} for the remaining subscription period will be sent from your Stripe account. Please ensure you have sufficient funds in your Stripe balance to process the refund before proceeding.`;
    } else {
        modelDesc = (subsciberIds.length > 1) 
            ? 'Are you sure you want to proceed with deleting these subscribers?'
            : 'Are you sure you want to proceed with deleting this subscriber?';
    }

    useEffect(() => {    
        const handleKeyDown = (e) => {
            const deleteMediaElement = document.getElementById('deleteMedia');
            if (e?.key === 'Enter' && isOpen && deleteMediaElement?.children?.length > 0) {
                deleteSubscriber();
            } else if(e?.key === "Escape"){
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const handleKeyPress = async (e) => {
        if (e.key === 'Enter') {
            await deleteSubscriber();
        }
    };

    const deleteSubscriber = async () => {
        try {
            setIsLoading(true);
            let num = subsciberIds.length;

            await Promise.all(
                subsciberIds?.map(async (subsciberId) => {
                    await axios.post(
                        `${process.env.REACT_APP_API_URL}/subscriber/deletesubscriber/${subsciberId}`,
                        {
                            isLast: (num > 1) ? false : true,
                            subsciberIds: subsciberIds
                        },
                    );
                    num = num - 1
                })
            );

            await fetchData();
            if(subsciberIds.length > 1){
                setShowMultiNotify(true)
            }else{
                setShowNotification(true)
            }
            if(setSelectedSubscriberLength) {
                setSelectedSubscriberLength(subsciberIds.length)
            }            
            onClose();
            setIsLoading(false);
            setSelectedItems([]) 
            setToggleSelect(!toggleSelect)

        } catch (error) {
            setIsLoading(false);
            if (error.status === 400) {
                const errorMsg = `You currently don't have sufficient funds in your Stripe balance to process a refund of ${currencySymbol}${remainCredits} ${currencyData?.currency?.toUpperCase() || 'USD'}. Please add funds to your Stripe account before proceeding with the refund. For more details, please visit: <a href="https://docs.stripe.com/get-started/account/add-funds" target="_blank">How to add funds to your Stripe account.</a>`;
                setErrorMassage(errorMsg);
            } else {
                setErrorMassage(error?.response?.data?.error);
            }
        }
    }

    return (
        <>
        <div className='welcomeModal deleteCategoryPage' ref={modelRef} id="deleteMedia">
            <div className="popupTop popupTopClose closePlan">
              <img src={close} onClick={e => { onClose() }} alt="Icon" />
            </div>
            <h3 className='popupTitle'>{modelTitle}</h3>
            <p className='popupDesc'>{modelDesc}</p>            
            {errorMassage && 
                <p className="error-message" dangerouslySetInnerHTML={{ __html: errorMassage }}></p>
            }
            <div className="btnGroupLink" id='deleteMedia'>
                <button className="secondary-button button" type="button" onClick={onClose}>Cancel</button>
                <button className="primary-button button" type="button" onClick={() => deleteSubscriber()} onKeyPress={(e) => handleKeyPress(e)}>
                    {isLoading ?
                        <div className="settingPage-loader">
                            <div className="ring-loader"></div>
                        </div>
                        : "Delete"}
                </button>
            </div>
        </div>
        </>
    )
}

export default DeleteSubscriberModel